var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.initialized)?[_c('the-header'),_c('v-main',[_c('router-view')],1)]:(_vm.loading)?[_c('loading-layout')]:[_c('error-layout',{attrs:{"error":"Service is unavailable","message":"Please, try again later or contact support"}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }